import {
	Card,
	CardContent,
	Tabs,
	TabsList,
	TabsTriggerWithNumber,
} from "@dune/ui";
import React, { useState } from "react";
import { useGetDuneDocuments } from "../../../api/queries/dashboard.queries";
import { DocumentsList } from "./DocumentsList";

export const DocumentsSection: React.FC = () => {
	const [activeFilter, setActiveFilter] = useState("tous");
	const { data: documentsData, isLoading } = useGetDuneDocuments();

	const tabs = [
		{
			value: "tous",
			label: "Tous",
			count: isLoading ? 0 : documentsData?.totalCount || 0,
		},
		{
			value: "apporteurs",
			label: "Apporteurs",
			count: isLoading ? 0 : documentsData?.categories.apporteurs || 0,
		},
		{
			value: "projets",
			label: "Projets",
			count: isLoading ? 0 : documentsData?.categories.projets || 0,
		},
		{
			value: "propositions",
			label: "Propositions",
			count: isLoading ? 0 : documentsData?.categories.propositions || 0,
		},
		{
			value: "contrats",
			label: "Contrats",
			count: isLoading ? 0 : documentsData?.categories.contrats || 0,
		},
	];

	return (
		<div className="h-full flex flex-col overflow-hidden bg-gray-50 rounded-lg border border-gray-100">
			<Card className="h-full flex flex-col overflow-hidden bg-transparent border-none shadow-none">
				<CardContent className="flex-1 overflow-hidden p-4 pt-0">
					<div className="flex-shrink-0 pb-4">
						<div className="flex items-center text-xl font-semibold text-text-main-blue">
							Documents à traiter
							{!isLoading && (
								<span className="ml-2 text-sm font-normal text-gray-500">
									{documentsData?.totalCount}
								</span>
							)}
						</div>
					</div>
					<div className="h-full flex flex-col">
						<div className="flex-shrink-0 mb-4">
							<Tabs value={activeFilter} onValueChange={setActiveFilter}>
								<TabsList className="grid w-full grid-cols-5">
									{tabs.map((tab) => (
										<TabsTriggerWithNumber
											key={tab.value}
											value={tab.value}
											number={tab.count}
											variant="compact"
											className="flex gap-2"
										>
											{tab.label}
										</TabsTriggerWithNumber>
									))}
								</TabsList>
							</Tabs>
						</div>
						<div className="flex-1 overflow-hidden">
							<DocumentsList activeFilter={activeFilter} />
						</div>
					</div>
				</CardContent>
			</Card>
		</div>
	);
};
